











import GlobalMixin from "@/shared/mixins/globalMixin";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { Component, Mixins, Watch } from "vue-property-decorator";
import DashboardTvAtendimentos from "./DashboardTvAtendimentos.vue";
import DashboardTvDiario from "./DashboardTvDiario.vue";
import DashboardTvMarketing from "./DashboardTvMarketing.vue";
import DashboardTvMensal from "./DashboardTvMensal.vue";
import DashboardTvSuporte from "./DashboardTvSuporte.vue";
import DashboardTvVideo from "./DashboardTvVideo.vue";

const interval = 40000; //40 seg
const timeout = 300000; //5 min
declare type Stance = "diario" | "mensal" | "suporte" | "atendimentos" | "marketing" | "video";

@Component({
  components: { DashboardTvDiario, DashboardTvMensal, DashboardTvVideo, DashboardTvSuporte, DashboardTvAtendimentos, DashboardTvMarketing },
})
export default class DashboardTv extends Mixins(GlobalMixin) {
  data: string | null = "";
  stance: Stance = "diario"; //462px card
  intervalId = 0;
  timeoutVideo = 0;

  map: { [key: string]: Stance } = {
    diario: "mensal",
    mensal: "suporte",
    suporte: "atendimentos",
    atendimentos: "marketing",
    marketing: "diario",
  };

  mounted() {
    this.fetchInstancia();
  }

  @Watch("$route.params", { deep: true })
  @Watch("$route.query", { deep: true })
  fetchInstancia() {
    const query = this.$route.query;

    if (this.intervalId || this.timeoutVideo) this.clearInterval();

    if (query.data) {
      this.data = dayjs("" + query.data).format("YYYY-MM-DDT00:00:00");
    }

    if (query.stance) {
      this.stance = query.stance as Stance;
    } else {
      this.intervalId = setInterval(
        () => this.trocarInstancia(),
        (query.interval && +query.interval) || interval
      );
    }

    this.startTimeoutVideo();
  }

  trocarInstancia() {
    if (this.stance == "video") {
      delete this.map["video"];
      this.map["marketing"] = "diario";
      this.stance = "diario";
      this.startTimeoutVideo();
    } else this.stance = this.map[this.stance];
  }

  beforeDestroy() {
    this.clearInterval();
  }

  startTimeoutVideo() {
    const query = this.$route.query;
    this.timeoutVideo = setTimeout(() => {
      this.setVideo();
    }, (query.video && +query.video) || timeout);
  }

  setVideo() {
    this.map["marketing"] = "video";
    this.map["video"] = "diario";
  }

  clearInterval() {
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutVideo);
  }
}
